import React, { useContext, useMemo, useState } from 'react';
import PageLayout from '../../pagelayout';
import { useFormatMessageFor } from '../../i18n/translation';
import translations from './addSystembruker.i18n';
import { TextInput } from '../../components/input';
import * as css from './addSystembruker.module.scss';
import Button from '../../components/button';
import validateEmail from '../../util/validateEmail';
import { AdminApiContext } from '../../api/AdminApiContext';
import { NotificationFunctionContext } from '../../components/notifications/notificationProvider';
import useAddErrorNotificationCallback from '../../hooks/useAddErrorNotificationCallback';

const AddSystembrukerPage = () => {
  const { brukerApi } = useContext(AdminApiContext);
  const { addSuccessNotification } = useContext(NotificationFunctionContext);
  const errorNotificationCallback = useAddErrorNotificationCallback();

  const [foedselsnummer, setFoedselsnummer] = useState('');
  const [feideId, setFeideId] = useState('');
  const [fornavn, setFornavn] = useState('');
  const [etternavn, setEtternavn] = useState('');
  const [epost, setEpost] = useState('');

  const labels = useFormatMessageFor(translations);

  const inputIsValid = useMemo<boolean>(
    () =>
      foedselsnummer.length === 11 &&
      validateEmail(feideId) &&
      feideId.endsWith('@sikt.no') &&
      !!fornavn &&
      !!etternavn &&
      validateEmail(epost),
    [foedselsnummer, feideId, fornavn, etternavn, epost],
  );

  const resetFields = () => {
    setFoedselsnummer('');
    setFeideId('');
    setFornavn('');
    setEtternavn('');
    setEpost('');
  };

  const submitFields = () => {
    if (inputIsValid) {
      brukerApi
        .systembrukerPost({
          brukerSystemPostDto: {
            foedselsnummer,
            feideId,
            fornavn,
            etternavn,
            epost,
          },
        })
        .then(() => {
          addSuccessNotification(labels.success);
          resetFields();
        })
        .catch(errorNotificationCallback);
    }
  };

  return (
    <PageLayout
      title={labels.pageTitle}
      subtitle={labels.pageSubtitle}
      isIndented
    >
      <div className={css.inputFields}>
        <div className={css.row}>
          <TextInput
            htmlId={'fnr'}
            onChange={setFoedselsnummer}
            label={labels.labelFnr}
            placeholder={labels.placeholderFnr}
            value={foedselsnummer}
            required
          />
          <TextInput
            htmlId={'feide'}
            onChange={setFeideId}
            label={labels.labelFeideId}
            placeholder={labels.placeholderFeideId}
            value={feideId}
            required
          />
        </div>
        <div className={css.row}>
          <TextInput
            htmlId={'fornavn'}
            onChange={setFornavn}
            label={labels.labelFornavn}
            placeholder={labels.placeholderFornavn}
            value={fornavn}
            required
          />
          <TextInput
            htmlId={'etternavn'}
            onChange={setEtternavn}
            label={labels.labelEtternavn}
            placeholder={labels.placeholderEtternavn}
            value={etternavn}
            required
          />
          <TextInput
            htmlId={'epost'}
            onChange={setEpost}
            label={labels.labelEpost}
            placeholder={labels.placeholderEpost}
            value={epost}
            required
          />
        </div>
        <div className={css.row}>
          <Button.Secondary disabled={!inputIsValid} onClick={submitFields}>
            {labels.btnLabel}
          </Button.Secondary>
        </div>
      </div>
    </PageLayout>
  );
};

export default AddSystembrukerPage;
